import { T } from '@tribeplatform/react-components/i18n'

import { EmbedSettings } from '../EmbedSettings.js'

export function EmbedRouter() {
  return <EmbedSettings />
}

export function EmbedBreadCrumb() {
  return <T id="Security.Embed" defaultMessage="Embed" />
}
